{
  "title": "Report a problem",
  "close": "Close",
  "minimize": "Minimize",
  "restore": "Back to your ticket",
  "ticketTitle": "Summary",
  "titlePlaceholder": "One line: what went wrong?",
  "category": "Type",
  "description": "What happened?",
  "descriptionPlaceholder": "What were you doing, and what did you expect instead?",
  "phiHint": "Patient identifiers are removed automatically before this is stored.",
  "contextTitle": "Attached automatically",
  "contextScreen": "Screen",
  "contextFailedRequests": "Recent failed requests",
  "contextVersion": "App version",
  "submit": "Send",
  "myTickets": "My tickets",
  "submitted": "Ticket sent",
  "submittedDetail": "Your ticket is {{publicRef}}. Support will follow up.",
  "submitFailed": "Could not send ticket",
  "submitFailedDetail": "Please try again. If it keeps failing, contact support directly.",
  "screenshot": "Screenshot (optional)",
  "attachScreenshot": "Attach a PNG",
  "screenshotHint": "PNG only, up to 5 MB. Every image passes through the redaction step before it is attached.",
  "attachmentTypeError": "Only PNG files can be attached.",
  "attachmentSizeError": "That file is larger than 5 MB.",
  "attachmentFailed": "Ticket sent, screenshot was not",
  "attachmentFailedDetail": "Ticket {{publicRef}} was created. You can attach the screenshot from My tickets.",
  "takeScreenshot": "Capture this screen",
  "capturing": "Capturing…",
  "captureUnsupported": "This browser cannot capture the screen. Attach a PNG instead.",
  "captureBlockedByImage": "An image on this page blocked the capture. Take a screenshot with your usual tool and attach it instead.",
  "captureEmpty": "The capture came out blank. Attach a PNG instead.",
  "captureFailed": "Could not capture this screen. Attach a PNG instead.",
  "redactorTitle": "Cover patient data",
  "redactorInstruction": "Drag over anything that identifies a patient. The black areas are burned into the image and cannot be undone once you attach it.",
  "redactorLoading": "Preparing the image…",
  "redactorFailed": "This image could not be opened for redaction.",
  "redactedAreas": "Covered areas",
  "undoArea": "Undo last",
  "clearAreas": "Clear all",
  "redactorAcknowledge": "I have covered all patient identifiers in this image.",
  "applyAndAttach": "Attach",
  "cancel": "Cancel"
}
